import Image from "next/image";
import Link from "next/link";
import React from "react";
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";

import {
  newsroomAnnouncements,
  newsroomBanner,
  walmartLogo,
} from "@/utils/images";
import classes from "@/styles/media/newsroom-main.module.css";
import { AnnouncementType } from "@/@types/Annoucement";
import { textEllipsisOverflow } from "@/utils/common-functions";
import { newsroomMedia } from "@/utils/content";

type Props = {
  announcements: AnnouncementType[];
};

const NewsroomMain = ({ announcements }: Props) => {
  return (
    <main className={classes.container}>
      <section>
        <Image
          className={classes.heroImg}
          src={newsroomBanner}
          alt={newsroomMedia.en.bannerImgAlt}
          height={1520}
          width={1520}
        />
        <div>
          <h1 className={classes.herHeading}>{newsroomMedia.en.bannerTitle}</h1>
        </div>
      </section>
      <section>
        <Container>
          <h3 className="text-center my-5">Annoucements</h3>
          <div className="annoucement-list">
            <Row>
              {announcements.map(
                ({ date, title, subtitle, imagePath, id }, i) => (
                  <Col xs={12} sm={12} md={6} lg={4} key={id}>
                    <Link key={i} href={`newsroom/${id}`}>
                      <Card className={classes.card}>
                        <CardBody>
                          <Image
                            src={
                              imagePath
                                ? imagePath
                                : "/images/newsroom/image-na-card.png"
                            }
                            alt="announcement illustration"
                            width={450}
                            height={150}
                          />
                          <div className={`p-2 ${classes.cardBody}`}>
                            <div className="date">{date}</div>
                            <p className="fw-bold text-black">
                              {textEllipsisOverflow(title, 100)}
                            </p>
                            <p className="subtitle">
                              {textEllipsisOverflow(
                                subtitle ? subtitle : "No subtitle",
                                70
                              )}
                            </p>
                          </div>
                        </CardBody>
                      </Card>
                    </Link>
                  </Col>
                )
              )}
            </Row>
          </div>
          <div className="text-center m-5">
            <Button className={classes.footerBtn} disabled>
              View More
            </Button>
          </div>
        </Container>
      </section>
    </main>
  );
};

export default NewsroomMain;
